import axios, { AxiosRequestConfig } from "axios";
import query from "./constants.api";

type TObject = object | string | null;
type TString = string | null;

// const config : AxiosRequestConfig = {baseURL: 'https://jsonplaceholder.typicode.com'}
// export const axiosInstance = axios.create(config);

const axiosInstance = async (method?: TString, url?: TString, data?: TObject, params?: TObject, type?: TString, baseUrl?: TString, customToken?: TString) => {
    const contentType = type ? type : 'application/x-www-form-urlencoded';

    const accessToken = 'Bearer ' + localStorage.getItem('sessionToken');
    const headers = {
        'content-type': contentType,
        Authorization: customToken ? customToken : accessToken,
    };

    let config: AxiosRequestConfig = {
        method: method ? method : 'GET',
        baseURL: baseUrl ? baseUrl : query.baseURL,
        url: url ? url : '',
        headers: headers,
        data: data ? data : null,
        params: params ? params : null,
    };

    return axios(config);

};

export default axiosInstance;
